module.exports = __webpack_public_path__ + "img/4.7b3b9e62.png";